import { pick } from 'lodash';
import { uppercaseFirstLetter } from 'src/common/utils/stringUtil';

export type Sorting = 'asc' | 'desc' | null;

export type SortingParam<T extends string = string> = {
  columnName: T;
  sort: Sorting;
} | null;

export const parseSortingParamsToString = (sorting: SortingParam) => {
  if (!sorting) {
    return;
  }

  return `${uppercaseFirstLetter(sorting.columnName)}:${sorting.sort?.toUpperCase()}`;
};

export const toggleSorting = (currentSorting?: 'asc' | 'desc' | null) => {
  if (!currentSorting) {
    return 'desc';
  }

  return currentSorting === 'asc' ? 'desc' : 'asc';
};

export const mapURLSearchParamsToSorting = <T extends string = string>(
  urlSearchParams: URLSearchParams,
) => {
  const params = Object.fromEntries(urlSearchParams);
  if (!params.columnName || !params.sort) {
    return null;
  }

  const sorting = pick(params, ['columnName', 'sort']) as SortingParam<T>;
  return sorting;
};
